<div class="grid grid-no-tb-gutter flex align-items-center">
    <div  class="col">
      <div  [overlayPanelTooltip]="groupsPanel">
        <div class="ellipsis-text group-text">
            {{row.userGroupsList}}
        </div>
      </div>
      <p-overlayPanel #groupsPanel>
        <div class="grid cursor-pointer">
                {{row.userGroupsList}}
        </div>
      </p-overlayPanel>
    </div>
    <div class="col flex-w-auto align-items-center gap-3 user-grid-action-buttons" >
      <div class="w-full">
        <button class="border-none background-none" type="button" pButton (click)="addOrEditUser(row)">
          <img src="assets/svg/Edit.svg" alt="edit-icon" />
        </button>
        <p-inputSwitch class="user-toggle" [(ngModel)]="row.isActive" name="userToggle" onLabel="On" offLabel="Off" (onChange)="handleUserStatus($event, row)">
        </p-inputSwitch>
      </div>
    </div>
  </div>